import { render, staticRenderFns } from "./ArrobaMedellinLiveKitRoom.html?vue&type=template&id=1a4eaf70&external"
import script from "./ArrobaMedellinLiveKitRoom.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinLiveKitRoom.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinLiveKitRoom.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports